module.exports = __webpack_public_path__ + "media/טיל.385ec16a.mp3";